import type { ConstellationDot } from '../types';
import { getGlowSparkStrength } from './poseHelpers';
import { getRingCoordinates, getRingPoint } from './ring';

type StillDotInput = Readonly<{
	active: boolean;
	color: string;
	index: number;
	timeSeconds: number;
}>;

const PULSE_RADIANS_PER_SECOND = 3.2;
const DOT_PHASE_OFFSET_RADIANS = 0.9;
const RADIAL_BOB_AMPLITUDE = 2.5;
const STILL_MOVEMENT_MULTIPLIER = 0.08; // When still, this allows the dots to move ever so slightly
const BASE_BRIGHTNESS = 0.68;
const BRIGHTNESS_PULSE_AMPLITUDE = 0.14;
const BASE_SCALE = 0.9;
const SCALE_PULSE_AMPLITUDE = 0.1;
const ACTIVE_GLOW_CONCENTRATION_POWER = 2.5;
const ACTIVE_MAXIMUM_GLOW_STRENGTH = 0.55;

export const createStillDot = ({
	active,
	color,
	index,
	timeSeconds,
}: StillDotInput): ConstellationDot => {
	const { count, radius, ringIndex } = getRingCoordinates(index);

	const pulse = Math.sin(timeSeconds * PULSE_RADIANS_PER_SECOND + index * DOT_PHASE_OFFSET_RADIANS);

	return {
		...getRingPoint(
			ringIndex,
			count,
			radius + pulse * RADIAL_BOB_AMPLITUDE * STILL_MOVEMENT_MULTIPLIER,
			0,
		),
		brightness:
			BASE_BRIGHTNESS + (pulse + 1) * BRIGHTNESS_PULSE_AMPLITUDE * STILL_MOVEMENT_MULTIPLIER,
		color,
		glowStrength: active
			? getGlowSparkStrength(pulse, ACTIVE_GLOW_CONCENTRATION_POWER, ACTIVE_MAXIMUM_GLOW_STRENGTH)
			: 0,
		scale: BASE_SCALE + (pulse + 1) * SCALE_PULSE_AMPLITUDE * STILL_MOVEMENT_MULTIPLIER,
	};
};
